module.exports = __webpack_public_path__ + "static/media/Huis-2-4.7a2abe0a.jpg";